import { api } from "../client";
import { AccountCompanyChangelog } from "../schema/AccountCompanyChangelog";
import { Config } from "../types";

type ApiRequestConfig = Config<AccountCompanyChangelog[]>;

export const getAccountCompanyChangelog = async (
  companyId: number,
  config?: ApiRequestConfig
) => {
  return api.get<AccountCompanyChangelog[]>(
    `account_companies/${companyId}/account_company_histories`,
    config
  );
};
